import axios from '@/axios';
import { useBookingStore } from '@/stores/booking';
import widgetSettings from '@/widget-settings';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { Company } from '../types';

export const useCompanyStore = defineStore('company', () => {
  const company = ref<Company>({} as Company);
  const settings = computed(() => company.value?.settings || {});

  const fetchCompany = (companyId: string) =>
    new Promise<void>((resolve) => {
      axios
        .get(`/companies/${companyId}`, {
          params: widgetSettings.widgetId
            ? {
                widget_id: widgetSettings.widgetId
              }
            : {}
        })
        .then(({ data }) => {
          company.value = data.company;

          const bookingStore = useBookingStore();
          bookingStore.locationId = data.company.primary_location_id;
          resolve();
        });
    });

  const employeeSelectionRequired = computed(
    () => settings.value.resource_selection === 'required'
  );
  const employeeSelectionDisabled = computed(
    () => settings.value.resource_selection === 'automatic'
  );
  const waitinglistEnabled = computed(
    () => settings.value.waiting_list && !widgetSettings.bookingId
  );
  const waitingListProEnabled = computed(
    () => waitinglistEnabled && settings.value.waiting_list_pro
  );
  const requestBooking = computed(
    () => !!settings.value.appointment_requires_confirmation?.enabled
  );

  return {
    company,
    settings,
    fetchCompany,
    employeeSelectionRequired,
    employeeSelectionDisabled,
    waitinglistEnabled,
    waitingListProEnabled,
    requestBooking
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCompanyStore, import.meta.hot));
}
